import store from '@/store/store';

export default {
  path: 'referrals',
  name: 'app-view-referrals',
  component: () => import('@/views/app/view_referrals/ViewReferrals.vue'),
  meta: {
    pageTitle: ''
  },
  beforeEnter: async (to, from, next) => {
    to.meta.pageTitle = 'view_referrals.header_title';
    const referralsResource = await store.state.router.privateRoot.$request().$get('referrals');
    store.commit('router/updateRouteProp', {
      property: 'referralsResource',
      value: referralsResource
    });
    next();
  },
  props: () => ({
    referralsResource: store.state.router.referralsResource
  })
};
